/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { BaseButtonAdapter } from './base/base-button-adapter';
export class ButtonAdapter extends BaseButtonAdapter {
    constructor(component) {
        super(component);
    }
    toggleStateLayer(value) {
        this._stateLayerElement.disabled = !value;
    }
}
